import { Region } from "@/types/packages/data-only/SearchPackagesList";
import { cleanString } from "./cleanString";
import { Country } from "./generateSiteMap";

interface PropsType {
  country?: Country;
  region?: Region;
  searchQuery: string;
  isGlobal?: boolean;
}

export function isSearchQueryMatch({
  country,
  region,
  searchQuery,
  isGlobal,
}: PropsType): boolean {
  if (country) {
    if (isGlobal) {
      const res = ["global", "international"].some((item) =>
        cleanString(item).includes(searchQuery.trim()),
      );
      if (res) return true;
    }

    return (
      cleanString(country.name).includes(searchQuery.trim()) ||
      cleanString(country.code).includes(searchQuery.trim()) ||
      cleanString(
        country.local_state_code ? country.local_state_code : "",
      ).includes(searchQuery.trim()) ||
      cleanString(country.code_alpha3).includes(searchQuery.trim())
    );
  }

  if (region) {
    const res = ["region", "regional"].some((item) =>
      cleanString(item).includes(cleanString(searchQuery.trim())),
    );

    if (res) return true;

    return (
      cleanString(region.name).includes(searchQuery.trim()) ||
      region.countries.some((country) =>
        isSearchQueryMatch({ country, searchQuery }),
      )
    );
  }

  return false;
}
